module.exports = __webpack_public_path__ + "static/img/img-circle.73906c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/img-circle.svg
// module id = AMwe
// module chunks = 0